<template>
  <div class="auth-logout">
  </div>
</template>

<script>
export default {
  name: 'AuthLogout',
  mounted() {
    this.$store.dispatch('auth/logout');
    this.$router.push('login', () => {}, () => {});
  },
};
</script>

<style scoped>
</style>
